
import Loading from 'vux/src/components/loading/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'

import { mapState } from 'vuex'

export default {
name: 'App',
components: {
Loading,
},
created() {

const ua = window.navigator.userAgent.toLowerCase();
const isWechat = ua.indexOf('micromessenger') !== -1;


if (!isWechat) {
window.location.href = "https://hmsfans.com/homepage.html";
return;
}

const hrefParts = window.location.href.split('?');
let code = null;

if (hrefParts.length === 2) {
const params = hrefParts[1];
const paramsObj = querystring.parse(params);
code = paramsObj['code'];
}

if (!code) {

const appid = "wxeeb7fae40f0a7ba1";
const loginUrl = encodeURIComponent(window.location.href);
const scope = "snsapi_userinfo";
window.location.href =
"https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
appid +
"&redirect_uri=" +
loginUrl +
"&response_type=code&scope=" +
scope +
"&state=STATE#wechat_redirect";
} else {

this.$ajax.post({
url: this.$apiUrls.wechatLogin,
isLoading: false,
data: { code },
success: res => {
const userId = res.data.id;
window.userId = userId;


if (window.history && window.history.replaceState) {
const cleanUrl = window.location.origin + window.location.pathname;
window.history.replaceState({}, document.title, cleanUrl);
}

if (res.data.status === 0) {
this.$vux.toast.text(res.data.msg, 'center');
return;
}

if (window.loaduser) {
window.loaduser();
}
if (window.loadgoodslist) {
window.loadgoodslist();
}
},
error: err => {

console.error('微信登录请求失败', err);
}
});
}
},
computed: {
...mapState({
isLoading: state => state.vux.isLoading,
text: state => state.vux.loaddingText
})
},
methods: {
getUrlParam(name) {
const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
const r = window.location.search.substr(1).match(reg);
if (r != null) {
return decodeURIComponent(r[2]);
}
return null;
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue